export const PHONE = 'phone';
export const DESKTOP = 'desktop';
export const GRID = 'grid';

export const mediaQueries = {
  [PHONE]: '(max-width: 600px)',
  [DESKTOP]: '(min-width: 601px)',
  [GRID]: '(max-width: 1284px)'
};
